import apolloClient from '../../lib/apolloClient'
import { Unarray } from '../../types'
import { GET_PAGES_QUERY } from '../queries'
import { GetPagesQuery, GetPagesQueryVariables } from '../__generated__/types'

export const fetchPage = async (
  locale: string,
  slug: string,
): Promise<Unarray<GetPagesQuery['pages']>> => {
  const translationsFilter = { languages_code: { _eq: locale } }
  const filter = slug
    ? {
        filter: {
          slug: {
            _eq: slug,
          },
        },
      }
    : undefined
  const {
    data: { pages },
  } = await apolloClient.query<GetPagesQuery, GetPagesQueryVariables>({
    query: GET_PAGES_QUERY,
    variables: {
      ...filter,
      translations_filter: translationsFilter,
      titles_translations_filter: translationsFilter,
      subtitles_translations_filter: translationsFilter,
      cards_translations_filter: translationsFilter,
      rich_texts_translations_filter: translationsFilter,
      texts_with_images_translations_filter: translationsFilter,
      images_translations_filter: translationsFilter,
    },
  })
  return pages[0]
}
